import { createState, State } from '@hookstate/core';

interface ResetMartkersState {
  appStore: boolean;
  ticket: boolean;
  payment: boolean;
  question: boolean;
  upload: boolean;
  product: boolean;
}

const resetMarkersState = createState({
  appStore: false,
  ticket: false,
  payment: false,
  question: false,
  upload: false,
  product: false,
});

const resetMarkers = (state: State<ResetMartkersState>) => ({
  get appStore() {
    return state.appStore;
  },
  get ticket() {
    return state.ticket;
  },
  get payment() {
    return state.payment;
  },
  get question() {
    return state.question;
  },
  get upload() {
    return state.upload;
  },
  get product() {
    return state.product;
  },
  mark: (key: keyof ResetMartkersState) => {
    state.merge({ [key]: true });
  },
});

export default function ResetMarkersAccess() {
  return resetMarkers(resetMarkersState);
}
